import { render, staticRenderFns } from "./BuildingStatisManage.vue?vue&type=template&id=e3f0d972&"
import script from "./BuildingStatisManage.vue?vue&type=script&lang=js&"
export * from "./BuildingStatisManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports